import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FlightSection from './FlightSection';
import Header from './Header';
import useVoiceAnnouncements from '../hooks/useVoiceAnnouncements';
import './FlightDisplay.css';

const FlightDisplay = () => {
  const { category } = useParams();
  const [arrivals, setArrivals] = useState([]);
  const [departures, setDepartures] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [loading, setLoading] = useState(true);

  // Voice announcements hook - detects status changes and announces them
  // Pass category to only announce flights matching the current view
  useVoiceAnnouncements(arrivals, departures, category);

  useEffect(() => {
    const fetchFlights = async () => {
      try {
        const [arrivalsRes, departuresRes] = await Promise.all([
          axios.get(`/api/flights/arrivals/${category}`),
          axios.get(`/api/flights/departures/${category}`)
        ]);

        setArrivals(arrivalsRes.data.flights || []);
        setDepartures(departuresRes.data.flights || []);
        setLastUpdated(arrivalsRes.data.lastUpdated || departuresRes.data.lastUpdated);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching flights:', error);
        setLoading(false);
      }
    };

    fetchFlights();
    
    // Refresh every 15 seconds
    const interval = setInterval(fetchFlights, 15000);
    
    return () => clearInterval(interval);
  }, [category]);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading flight information...</p>
      </div>
    );
  }

  const categoryTitle = category === 'domestic' ? 'Domestic' : 'International';

  return (
    <div className="flight-display">
      <Header category={categoryTitle} lastUpdated={lastUpdated} />
      <div className="display-container">
        <FlightSection 
          type="arrivals" 
          flights={arrivals}
          category={categoryTitle}
        />
        <FlightSection 
          type="departures" 
          flights={departures}
          category={categoryTitle}
        />
      </div>
    </div>
  );
};

export default FlightDisplay;

